export const LEARN_MORE = 'Learn more';
export const BANNER = {
  text: "Once you're selling courses on your Shopify store, you might want to level up by further customizing your student experience, or selling courses in other places.",
};
export const THINKIFIC_DASHBOARD = {
  title: 'Thinkific Dashboard',
  text: 'Learn how to grow your education business with everything Thinkific has to offer including customization, marketing and reporting tools.',
  button: {
    text: 'View Thinkific dashboard',
  },
};

export const UPGRADE_EXPERIENCE = {
  title: "Upgrade to customize your students' experience",
  texts: [
    'Remove Thinkific branding from your student experience.',
    'Customize your student experience more with certificates, compliance, and assignments, etc.',
    'Add drip (scheduled) content.',
    'Use a custom domain for your course content.',
    'Connect other tools with webooks or the API.',
  ],
  buttons: [
    {
      text: 'Remove branding',
    },
    {
      text: 'Add a domain',
    },
  ],
  links: [
    'https://support.thinkific.com/hc/en-us/articles/360030725193-Remove-Thinkific-Branding',
    'https://support.thinkific.com/hc/en-us',
    'https://support.thinkific.com/hc/en-us/articles/360030741033-Drip-Schedule',
    'https://support.thinkific.com/hc/en-us/articles/360030360074-Custom-Domains',
    'https://support.thinkific.com/hc/en-us/articles/360030353194-Getting-Started-with-the-AP',
  ],
};

export const BUILD_COURSE = {
  title: 'Build a course-specific site',
  texts: [
    'Choose a theme for your site.',
    'Build and style your site',
    'Add a custom domain for your site',
  ],
  buttons: [
    {
      text: 'See theme library',
    },
    {
      text: 'Explore Site Builder',
    },
    {
      text: 'Add a domain',
    },
  ],
};

export const GET_IN_TOUCH = {
  title: 'Get in touch',
  text: "If you need help, reach out to our support team at support@thinkific.com and we'll be happy to help.",
  button: {
    url: 'mailto:support@thinkific.com',
    text: 'Email us',
  },
};
